'use client';
import { useCallback, useState } from 'react';

export default function useToggle(initialState = false) {
  const [value, setValue] = useState<boolean>(initialState ?? false);

  const toggleValue = useCallback(
    (value?: boolean) =>
      setValue(current => (typeof value === 'boolean' ? value : !current)),
    []
  );

  return { value, toggleValue };
}
